<template>
  <div
    class="plan"
    :class="{ 'plan--gradient' : isGradient }"
    :style="cssVars"
  >
    <div v-if="!!$slots.disclaimer" class="plan__disclaimer">
      <slot name="disclaimer" />
    </div>
  
    <div class="plan__name">{{ plan.name }}</div>

    <div class="plan__pricing">
      <div class="plan__pricing__amount">{{ plan.amount | toCurrency }} em até</div>
      <div class="plan__pricing__disclaimer">
        <div v-if="!$slots.pricingDisclaimer">
          <span>{{ plan.max_installments }}x de </span>
          <strong class="plan__pricing__disclaimer__amount">{{ plan.max_installment_amount | toCurrency }}</strong>
        </div>
        <!-- <span v-if="!$slots.pricingDisclaimer">Economia de <strong>{{ plan.discount_amount | toCurrency }}</strong></span> -->
        <slot v-else name="pricingDisclaimer" />
      </div>
    </div>

    <ul class="plan__advantages">
      <li>
        <CheckCircleSVG /> Teste por 7 dias
      </li>
      <li>
        <CheckCircleSVG /> Acesso por {{  recurrencyPeriod }}
        <span v-if="recurrencyPeriod > 1">meses</span>
        <span v-else>mês</span>
      </li>
      <li>
        <CheckCircleSVG /> Acesso imediato a plataforma
      </li>
      <li>
        <CheckCircleSVG /> Acesso aos novos cursos
      </li>
    </ul>

    <div class="plan__button__box" @click="goToCheckout">
      <slot name="button" v-if="!!$slots.button" />
      <button v-else class="plan__button">EU QUERO!</button>
    </div>
  </div>
</template>

<script>
  import CheckCircleSVG from '@/components/svg/CheckCircleSVG'

  export default {
    components: {
      CheckCircleSVG,
    },

    props: {
      plan: { type: Object, required: true },
      primary: { type: String, required: true },
      secondary: { type: String, default: null },
    },

    computed: {
      cssVars () {
        return {
          '--primary-color' : this.primary,
          '--secondary-color' : this.secondary
        }
      },

      isGradient () {
        return !!this.secondary
      },

      recurrencyPeriod () {
        return Math.round(this.plan.recurrency_period / 30)
      },

      queryParams () {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        delete params.off
        delete params.checkoutMode
        delete params.bid
        delete params.sck

        return Object.entries(params).map(([key, value]) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }).join('&');
      }
    },

    methods: {
      goToCheckout () {
        this.$gtm.trackEvent({ event: 'landing.click-plan', item_id: this.plan.name })

        
        let url = this.plan.external_checkout_url
        if (this.queryParams) {
          if (!url.includes('?')) url += '?'
          url +='&'+encodeURI(this.queryParams)
        }
        
        window.location.href = url
      }
    }
  }
</script>

<style scoped lang="scss">
  .plan {
    $p: &;

    position: relative;
    border: 2px solid var(--primary-color);
    border-radius: 10px;
    font-family: 'Inter';
    color: var(--primary-color);

    &__name {
      font-size: 2.125rem;
      line-height: 2.25rem;
      font-weight: 700;
      text-align: center;
      padding: 2.25rem 15px;
    }

    &__disclaimer {
      position: absolute;
      width: 100%;
      text-align: center;
      transform: translateY(-50%);

      span {
        background: var(--primary-color);
        border: 2px solid #fff;
        border-radius: 30px;
        display: inline-block;
        font-size: 1rem;
        text-align: center;
        font-weight: 700;
        padding: 3px 20px;
      }
    }

    &__pricing {
      position: relative;
      padding: 10px 15px;
      text-align: center;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: var(--primary-color);
        opacity: .2;
        z-index: 0;
      }

      &__amount,
      &__disclaimer {
        position: relative;
        z-index: 1;
      }

      &__amount {
        opacity: 0.8;
        font-size: 15px;
        font-weight: 700;
      }

      &__disclaimer {
        font-size: 16px;
        font-weight: 600;
        opacity: 0.8;

        strong { font-weight: 900 }

        &__amount,
        ::v-deep &__amount {
          font-size: 32px;
        }
      }
    }

    &__advantages {
      margin-left: 20%;
      padding: 30px 15px 0;
      font-size: 16px;
      font-weight: 600;

      @media (max-width: 1366px) {
        margin-left: 15%;
      }

      li {
        padding: 5px 0;

        ::v-deep svg { fill: var(--primary-color) }
      }

      &__spotlight {
        background: #fff;
        border-radius: 30px;

        ::v-deep svg { fill: #ff8000 !important }
        ::v-deep svg path { fill: #fff !important }
      }
    }

    &__button__box {
      transform: translateY(50%);
      text-align: center;
    }

    &__button {
      border: 2px solid transparent;
      color: #fff;
      background: var(--primary-color);
      padding: 0.9375rem 2.5rem;
      font-size: 1.0625rem;
      font-family: 'Inter';
      font-weight: 700;
      border-radius: 40px;
      transition: .5s all;

      &:hover {
        background-color: #fff;
        border-color: var(--primary-color);
        color: var(--primary-color);
        box-shadow: 0 0 0 5px rgba(#fff, .2), 0px 30px 41px 1px rgba(0, 0, 0, 0.25);
      }
    }

    &--gradient {
      background: linear-gradient(180deg, var(--primary-color) 0%, var(--secondary-color) 100%);
      color: #fff;

      #{$p}__pricing:before { background: #fff }

      #{$p}__advantages {
        svg { fill: #fff }
        svg ::v-deep path { fill: var(--primary-color)!important }
      }
    }
  }
</style>